// ======================================================================
// File Name       : usageSettingLive
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const RECEIVED_LIVE_RESERVATION_TIME = 'RECEIVED_LIVE_RESERVATION_TIME';
export const RECEIVED_SERVICE_INFO = 'RECEIVED_SERVICE_INFO';
export const RECEIVED_LIVE_RESERVED_LIST = 'RECEIVED_LIVE_RESERVED_LIST';
export const RECEIVED_LIVE_RESERVED_DETAIL = 'RECEIVED_LIVE_RESERVED_DETAIL';
export const ADD_USER_LIST_TO_LIVE = 'ADD_USER_LIST_TO_LIVE';
export const REMOVE_USER_FROM_LIVE = 'REMOVE_USER_FROM_LIVE';
export const SAVE_LIVE_AUTHORITY_IDS = 'SAVE_LIVE_AUTHORITY_IDS';
export const RESET_EDITING_LIVE_USERS = 'RESET_EDITING_LIVE_USERS';
export const RECEIVE_JOINABLE_LIVE_LIST = 'RECEIVE_JOINABLE_LIVE_LIST';
export const REMOVE_ALL_USER_FROM_LIST = 'REMOVE_ALL_USER_FROM_LIST';
// #7129 START
export const RESET_LIVE_RESERVED_DETAIL = 'RESET_LIVE_RESERVED_DETAIL';
// #7129 END
